import request from './index';

export function addNews(data) {
  return request.post('officialPageNews/add', data);
}

export function updateNews(data) {
  return request.post('officialPageNews/update', data);
}

export function deleteNews(id) {
  return request.post('officialPageNews/delete', { id });
}

export function getNewsDetail(id) {
  return request.get('officialPageNews/detail', { params: { id } });
}

export function getNewsPage(params) {
  return request.get('officialPageNews/page', { params });
}

export function getNewsList(params) {
  return request.get('officialPageNews/list', { params });
}

export function setNewsTop(id) {
  return request.post('officialPageNews/setTop', { id });
}
